class TabsContainer extends HTMLElement {
  constructor() {
    super();

    this.tabs = null;
    this.panel = null;
  }

  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-ref="tab"]'));
    this.panel = this.querySelector('[data-ref="tabs-panel"]');

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        this.#resetTabs();
        this.#selectTab(tab);
      });
    });

    this.#selectTab(this.tabs[0]);
  }

  #getExternalSections() {
    const externalSections = new Map();

    this.tabs.forEach((tab) => {
      const sectionId = tab.dataset.sectionId?.trim();
      if (!sectionId || externalSections.has(sectionId)) return;

      const targetSection = document.getElementById(sectionId);
      if (!targetSection) return;

      externalSections.set(sectionId, targetSection.closest('.shopify-section') || targetSection);
    });

    return externalSections;
  }

  #selectTab(tab) {
    const sectionId = tab.dataset.sectionId?.trim();
    const tabContent = tab.querySelector('template')?.content.querySelector('[data-ref="tab-content"]');

    this.#toggleExternalSections(sectionId);

    if (sectionId) {
      this.panel.innerHTML = '';
      this.panel.hidden = true;
    } else if (tabContent) {
      this.panel.innerHTML = tabContent.innerHTML;
      this.panel.hidden = false;
    }

    tab.classList.add('active');
  }

  #toggleExternalSections(activeSectionId) {
    this.#getExternalSections().forEach((section, sectionId) => {
      section.hidden = sectionId !== activeSectionId;
    });
  }

  #resetTabs() {
    this.tabs.forEach((tab) => {
      tab.classList.remove('active');
    });
    this.panel.innerHTML = '';
    this.panel.hidden = false;
  }
}

if (!customElements.get('tabs-container')) {
  customElements.define('tabs-container', TabsContainer);
}
